<template>
  <v-container fluid>
    <PageTitle title="Application" />

    <ApiDataForm
      data-api="apps"
      form-mode="edit"
      can-save="true"
      @after-save="afterSave"
    />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

import ApiDataForm from "../ui/shared/ApiDataForm.vue";
import uiServ from "../../services/ui";
import PageTitle from "../ui/shared/PageTitle.vue";

export default {
  name: "Brand",

  components: { ApiDataForm, PageTitle },

  computed: {
    ...mapGetters(["t_saveComplete"]),
  },

  methods: {
    afterSave() {
      uiServ.showMessage(this, this.t_saveComplete, "success");
      this.$store.commit("app/reset");
      this.$store.dispatch("app/getApp");
    },
  },
};
</script>
